module.exports = '1.6.1';



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/sockjs-client/lib/version.js
// module id = ../../../../sockjs-client/lib/version.js
// module chunks = 19